import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import p from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import { warn as E } from "../../_utils/naive/warn.js";
import R from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import { call as f } from "../../_utils/vue/call.js";
import { ref as m, toRef as s } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
function k(o, r) {
  const a = p(() => {
    for (const e of o.columns)
      if (e.type === "expand")
        return process.env.NODE_ENV !== "production" && !e.renderExpand && E("data-table", "column with type `expand` has no `renderExpand` prop."), e.renderExpand;
  }), t = p(() => {
    let e;
    for (const n of o.columns)
      if (n.type === "expand") {
        e = n.expandable;
        break;
      }
    return e;
  }), l = m(o.defaultExpandAll ? a != null && a.value ? (() => {
    const e = [];
    return r.value.treeNodes.forEach((n) => {
      var d;
      !((d = t.value) === null || d === void 0) && d.call(t, n.rawNode) && e.push(n.key);
    }), e;
  })() : r.value.getNonLeafKeys() : o.defaultExpandedRowKeys), c = s(o, "expandedRowKeys"), u = s(o, "stickyExpandedRows"), x = R(c, l);
  function i(e) {
    const {
      onUpdateExpandedRowKeys: n,
      "onUpdate:expandedRowKeys": d
    } = o;
    n && f(n, e), d && f(d, e), l.value = e;
  }
  return {
    stickyExpandedRowsRef: u,
    mergedExpandedRowKeysRef: x,
    renderExpandRef: a,
    expandableRef: t,
    doUpdateExpandedRowKeys: i
  };
}
export {
  k as useExpand
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/use-expand.js
// module id = 1660
// module chunks = 67